export const APP_MODEL_DATA = {
    SUPPORTED_LANG_TRANSLATIONS: ['en', 'es', 'fr', 'it', 'nl', 'pt'],
    EXPIRE_INTERVAL_BEFORE : 180, // 3 minutes in seconds
    GET_EXPIRY_TIME: 86400, // 1 day expiry time for refresh token
    TOKEN_INTERVAL:30000,
    RETRY_TIMEOUT:10000,
    ALLOWED_ROLES : ['admin','manager','user'],
    NOT_ALLOWED_ROLES : ['internal'],
    APP_SPINNER: 'app-spinner',
    CURRENT_PAGE: 1,
    ITEMS_PER_PAGE:10,
    MAXIMUM_PAGE_SIZE:10,
    RETRY_ATTEMPTS: 2,
    SIGN_IN_MSG_TIMEOUT: 5000,
    DEFAULT_OFFSET: 0,
    DEFAULT_PAGESIZE: 10,
    SOM_TEMP_WARNING_THRESHOLD: 185,
    DEFAULT_COLUMN_NAME: 'created_at',
    SITES_DEFAULT_COLUMN_NAME: 'createdAt',
    SORT_DESC: 'desc',
    SORT_ASC: 'asc',
    PAGINATION_OFFSET:10,
    ROLE_SUPPORT_USER: 'support_user',
    ROLE_SUPPORT: 'support',
    ROLE_USER: 'user',
    ROLE_POOLPRO: 'poolpro_user',
    LANG_VERSION: '1.4',
    LANG_KEY_FOR_NO_RECORDS_FOUND: 'lang.no_records_found',
    LANG_KEY_FOR_NO_MATCHING_RESULTS: 'lang.no_matching_results',
    DEFAULT_SORT_COLUMN_NAME_SITES: 'siteName',
    INPUT_TYPE_PASSWORD: 'password',
    INPUT_TYPE_TEXT: 'text',
    PREVIOUS_ARROW: '< ',
    NEXT_ARROW: ' >',
    FIRST_TEXT: 'First',
    LAST_TEXT: 'Last',
    PREVIOUS: 'Prev',
    NEXT: 'Next',
    SITES: 'sites',
    SUPPORT_USERS: 'support-user',
    SUCCESS: 'Success',
    USER_TYPE_CONSUMER: 'consumer',
    ADD_USER: 'Are you sure you want to add this user?',
    CONTROLLER_ADDED: 'The controller has been added to the site',
    FULL_NAME: 'fullName',
    CONSUMER: 'consumer',
    SUPPORT: 'support',
    REMOVE_CONTROLLER_TITLE: 'Are you sure you want to remove this controller from the site?',
    REMOVE_CONTROLLER_DES: "Ensure removal is absolutely necessary first. After removal, all associated features will be removed from the site and unavailable to users. The controller will retain its settings and memory, but users' scenes and schedules may be affected.",
    USER: 'user',
    ADMIN: 'admin',
    INTERNAL: 'internal',
    MANAGER: 'manager',
    EQUIPMENT: 'equipment',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    ADD_PRO_BUSINESS: 'Blue Water Pool added successfully.',
    SITE_STATUS: 'siteStatus',
    SITE_CREATED: 'siteCreated',
    SITE_UPDATED: 'siteUpdated',
    SITE_USER_ADDED: 'siteUserAdded',
    SITE_USER_INVITED: 'siteUserInvited',
    SITE_USER_DELETED: 'siteUserDeleted',
    SITE_USER_LEFT: 'siteUserLeft',
    CHANGE_SITE_OWNERSHIP: 'changeSiteOwnership',
    CONTROLLER_ADDED_1: 'controllerAdded',
    CONTROLLER_REMOVED: 'controllerRemoved',
    FILTRATION_TURNED_ON: 'filtrationTurnedOn',
    FILTRATION_TURNED_OFF: 'filtrationTurnedOff',
    FILTRATION_SPEED_CHANGED: 'filterationSpeedChanged',
    SCENE_CREATED: 'sceneCreated',
    SCENE_DELETED: 'sceneDeleted',
    SCHEDULE_CREATED: 'scheduleCreated',
    SCHEDULE_DELETED: 'scheduleDeleted',
    SCHEDULE_UPDATED: 'scheduleUpdated',
    ENTER_SERVICE_MODE: 'enterServiceMode',
    EXIT_SERVICE_MODE: 'exitServiceMode',
    EQUIPMENT_CONNECTED: 'equipmentConnected',
    EQUIPMENT_DISCONNECTED: 'equipmentDisconnected',
    SYSTEM_CONNECTED: 'systemConnected',
    SYSTEM_DISCONNECTED: 'systemDisconnected',
    systemServiceModeOn:'systemServiceModeOn',
    systemServiceModeOff:'systemServiceModeOff',
    outcomeCreated:'outcomeCreated',
    outcomeDeleted:'outcomeDeleted',
    filtrationPumpSpeedChanged:'filtrationPumpSpeedChanged',
    spaceCreated:'spaceCreated',
    spaceDeleted:'spaceDeleted',
    spaceUpdated:'spaceUpdated',
    sceneStarted:'sceneStarted',
    sceneStopped:'sceneStopped',
    lightGroupTurnedOn:'lightGroupTurnedOn',
    lightGroupTurnedOff:'lightGroupTurnedOff',
    lightGroupColorChanged:'lightGroupColorChanged',
    lightGroupDeleted:'lightGroupDeleted',
    lightGroupCreated:'lightGroupCreated',
    thermostatTurnedOn:'thermostatTurnedOn',
    thermostatTurnedOff:'thermostatTurnedOff',
    thermostatUpdated:'thermostatUpdated',
    waterfeatureTurnedOn:'waterfeatureTurnedOn',
    waterfeatureTurnedOff:'waterfeatureTurnedOff',
    freezeProtectionUpdated:'freezeProtectionUpdated',
    THERMOSTAT_FEATURE_PROFILE: 'thermostat-feature-profile',
    POOL_PROS : 'poolPros',
    BUSINESSES:'businesses'

}
export const countries = [
    {
      code: 'US',
      name: 'United States',
      states: [
        { code: 'AL', name: 'Alabama' },
        { code: 'AK', name: 'Alaska' },
        { code: 'AZ', name: 'Arizona' },
        { code: 'AR', name: 'Arkansas' },
        { code: 'CA', name: 'California' },
        { code: 'CO', name: 'Colorado' },
        { code: 'CT', name: 'Connecticut' },
        { code: 'DE', name: 'Delaware' },
        { code: 'DC', name: 'District of Columbia'},
        { code: 'FL', name: 'Florida' },
        { code: 'GA', name: 'Georgia' },
        { code: 'HI', name: 'Hawaii' },
        { code: 'ID', name: 'Idaho' },
        { code: 'IL', name: 'Illinois' },
        { code: 'IN', name: 'Indiana' },
        { code: 'IA', name: 'Iowa' },
        { code: 'KS', name: 'Kansas' },
        { code: 'KY', name: 'Kentucky' },
        { code: 'LA', name: 'Louisiana' },
        { code: 'ME', name: 'Maine' },
        { code: 'MD', name: 'Maryland' },
        { code: 'MA', name: 'Massachusetts' },
        { code: 'MI', name: 'Michigan' },
        { code: 'MN', name: 'Minnesota' },
        { code: 'MS', name: 'Mississippi' },
        { code: 'MO', name: 'Missouri' },
        { code: 'MT', name: 'Montana' },
        { code: 'NE', name: 'Nebraska' },
        { code: 'NV', name: 'Nevada' },
        { code: 'NH', name: 'New Hampshire' },
        { code: 'NJ', name: 'New Jersey' },
        { code: 'NM', name: 'New Mexico' },
        { code: 'NY', name: 'New York' },
        { code: 'NC', name: 'North Carolina' },
        { code: 'ND', name: 'North Dakota' },
        { code: 'OH', name: 'Ohio' },
        { code: 'OK', name: 'Oklahoma' },
        { code: 'OR', name: 'Oregon' },
        { code: 'PA', name: 'Pennsylvania' },
        { code: 'RI', name: 'Rhode Island' },
        { code: 'SC', name: 'South Carolina' },
        { code: 'SD', name: 'South Dakota' },
        { code: 'TN', name: 'Tennessee' },
        { code: 'TX', name: 'Texas' },
        { code: 'UT', name: 'Utah' },
        { code: 'VT', name: 'Vermont' },
        { code: 'VA', name: 'Virginia' },
        { code: 'WA', name: 'Washington' },
        { code: 'WV', name: 'West Virginia' },
        { code: 'WI', name: 'Wisconsin' },
        { code: 'WY', name: 'Wyoming' }
      ]
    },
    {
      code: 'CA',
      name: 'Canada',
      states: [
        { code: 'AB', name: 'Alberta' },
        { code: 'BC', name: 'British Columbia' },
        { code: 'MB', name: 'Manitoba' },
        { code: 'NB', name: 'New Brunswick' },
        { code: 'NL', name: 'Newfoundland and Labrador' },
        { code: 'NT', name: 'Northwest Territories' },
        { code: 'NS', name: 'Nova Scotia' },
        { code: 'NU', name: 'Nunavut' },
        { code: 'ON', name: 'Ontario' },
        { code: 'PE', name: 'Prince Edward Island' },
        { code: 'QC', name: 'Quebec' },
        { code: 'SK', name: 'Saskatchewan' },
        { code: 'YT', name: 'Yukon'}
      ]
    }
];
export const siteRoleList = [
  {name: 'Builder'},
  {name: 'Routine Service and Maintenance'},
  {name: 'Equipment Troubleshooting and Repair'},
  {name: 'Upgrades'},
  {name: 'Renovation'}
];
